import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChallengeService } from './services/challenge.service';
import { LanguageService } from './services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth.service';
import { BackendService } from './services/backend.service';
import { AuthGuard } from './services/auth.guard';
import { ExerciseService } from './services/exercises.service';
import { SnackbarService } from '../theme/components/snackbar/snackbar.service';
import { StatisticService } from './services/statistic.service';
import { UserService } from './services/user.service';
import { ReminderService } from './services/reminder.service';
import { SupportService } from './services/support.service';
import { NotificationService } from '../theme/components/user-notification/notification.service';
import { AchievementService } from './services/achievement.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    AuthGuard,
    AuthService,
    BackendService,
    ChallengeService,
    AchievementService,
    LanguageService,
    TranslateService,
    ExerciseService,
    SnackbarService,
    NotificationService,
    StatisticService,
    UserService,
    ReminderService,
    SupportService,
  ],
})
export class SharedServicesModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/shared-services.module.ts